<template>
  <EpIconButton
      :disabled="isDisabled"
      color="primary"
      class="add-button"
      :class="{ 'add__button-hover': !isDisabled }"
      @click="$emit('add')"
  >
    <div class="icon-container">
      <AddIcon alt="Add icon" class="add-icon" />
    </div>
    <span class="mb-0 add-button_cursor">
      {{ addRowTitle }}
    </span>
  </EpIconButton>
</template>

<script>
import EpIconButton from '@/components/EpIconButton.vue'
import AddIcon from '@/components/icons/AddIcon.vue'

export default {
  name: 'addRowButtonComponent',
  components: {
    EpIconButton,
    AddIcon
  },
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    },
    addRowTitle: {
      type: String,
      default: 'Add Row'
    }
  }
}
</script>

<style lang="scss" scoped>
.add-button {
  background-color: #fff;
  border: 1px solid #f1f1f1;
  padding: 7px 15px;
  border-radius: 8px;
}

.icon-container {
  width: 24px;
  height: 24px;
  margin-right: 8px;
  display:flex;
  justify-content: center;
  align-items: center;
}

.add-icon {
  width: 16px;
  height: 16px;
}

@media (hover: hover) {
  .add__button-hover:hover {
    background-color: #bd0f72;
    color: #fff;
    opacity: 1;
  }
}
</style>
